import { AttachmentCarousel } from './AttachmentCarousel';
import Modal from 'react-modal';
import React from 'react';
import { ProgramAttachment } from '../../types';

export const AttachmentsModal = (props: {
  programId: string;
  nonDeletedAttachments: ProgramAttachment[];
  selectedIndex: number | null;
  onClose: () => void;
  onDelete: (attachment: ProgramAttachment) => void;
}) => {
  const { programId, nonDeletedAttachments, selectedIndex, onClose, onDelete } = props;
  return (
    <Modal
      isOpen={nonDeletedAttachments.length > 0 && selectedIndex !== null}
      overlayClassName="attachments-view__overlay"
      className="attachments-view__content"
      onRequestClose={onClose}
      testId="attachments-view__dialog"
      ariaHideApp={false}
    >
      {selectedIndex !== null && (
        <AttachmentCarousel
          programId={programId}
          attachments={nonDeletedAttachments}
          selectedIndex={Math.min(selectedIndex, nonDeletedAttachments.length - 1)}
          onDelete={onDelete}
          onClose={onClose}
        />
      )}
    </Modal>
  );
};
